<fhm-page [title]="title" [showSave]="newCustomerInstance"
  [showDone]="true"
  (doneClicked)="done()"
  (saveClicked)="save()"
  [description]="'fhm.customer-instance.description' | translate">
  @if (newCustomerInstance) {
    <fui-rows [formGroup]="formGroup">
      <fui-row>
        <fui-two-columns>
          <fui-column>
            <fui-text-control formControlName="id"
              [control]="formGroup.get('id')"
              [label]="'fhm.customer-instance.id.label'"
              [placeholder]="'fhm.customer-instance.id.placeholder'"
            [(ngModel)]="data.clientId"></fui-text-control>
          </fui-column>
          <fui-column>
            <fui-inline-information [title]="'fhm.customer-instance.messages.clientId.title'"
            [message]="'fhm.customer-instance.messages.clientId.message'"></fui-inline-information>
          </fui-column>
        </fui-two-columns>
      </fui-row>
    </fui-rows>
  }
  @if (!newCustomerInstance) {
    <fui-rows [formGroup]="formGroup">
      <fui-row>
        <fui-rows [label]="'Instance'">
          @if (featuresData) {
            <fui-content-layout-header-control slot="after">
              @if (!editingFeatures) {
                <fui-link-button [title]="'Edit'"
                (click)="edit()"></fui-link-button>
              }
            </fui-content-layout-header-control>
          }
          <fui-row>
            <fui-two-columns>
              <fui-column>
                <fui-text-control formControlName="id"
                  [control]="formGroup.get('clientId')"
                  [disabled]="!editingInstance || data.deploymentStatus === 'DEPLOYED'"
                  [label]="'fhm.customer-instance.id.label'"
                  [placeholder]="'fhm.customer-instance.id.placeholder'"
                  [(ngModel)]="data.clientId"></fui-text-control>
                <fui-tandem-field>
                  <fhm-customer-instance-group-select-control [(value)]="data.instanceGroupId"
                    [disabled]="!editingInstance"
                  [label]="'Group'"></fhm-customer-instance-group-select-control>
                  <fui-text-control formControlName="brand"
                    [control]="formGroup.get('brand')"
                    [disabled]="!editingInstance"
                    [label]="'fhm.customer-instance.brand.label'"
                    [placeholder]="'fhm.customer-instance.brand.placeholder'"
                    [(ngModel)]="data.brand"></fui-text-control>
                </fui-tandem-field>
              </fui-column>
              <fui-column>
                <fui-text-control [disabled]="true"
                  [label]="'fhm.customer-instance.deploymentType.label'"
                  [placeholder]="'fhm.customer-instance.deploymentType.placeholder'"
                  [value]="data.deploymentType"></fui-text-control>
                <fui-text-control [disabled]="true"
                  [label]="'fhm.customer-instance.deploymentStatus.label'"
                  [placeholder]="'fhm.customer-instance.deploymentStatus.placeholder'"
                  [value]="data.deploymentStatus"></fui-text-control>
              </fui-column>
            </fui-two-columns>
          </fui-row>
          @if (editingInstance) {
            <fui-row>
              <fhm-action-buttons>
                <fhm-remove-button [title]="'fhm.common.button.cancel'"
                (clicked)="cancelEdit()"></fhm-remove-button>
                <fhm-provision-button [title]="'fhm.common.button.save'"
                (clicked)="update()"></fhm-provision-button>
              </fhm-action-buttons>
            </fui-row>
          }
        </fui-rows>
      </fui-row>
      <fui-row >
        <fui-rows [label]="'Features'">
          @if (featuresData) {
            <fui-content-layout-header-control slot="after">
              @if (!editingFeatures) {
                <fui-link-button [title]="'Edit'"
                (click)="editFeatures()"></fui-link-button>
              }
            </fui-content-layout-header-control>
          }
          <fui-row>
            @if (featuresData) {
              <fui-column>
                <fui-two-columns>
                  <fui-column>
                    <fui-checkbox-control [label]="'Enable BI (do not use)'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.biEnabled"></fui-checkbox-control>
                    <fui-checkbox-control [label]="'Enable Sync'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.syncEnabled"></fui-checkbox-control>
                    <fui-checkbox-control [label]="'Enable Group Access'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.groupAccessEnabled"></fui-checkbox-control>
                    <fui-checkbox-control [label]="'Management Mode'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.managementMode"></fui-checkbox-control>
                    <fui-checkbox-control [label]="'Auto Register Devices (do not use)'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.autoRegisterDevices"></fui-checkbox-control>
                    <fui-checkbox-control [label]="'Use Automatic Payment Capture'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.useAutomaticPaymentCapture"></fui-checkbox-control>
                    <fui-text-control [label]="'Override Service Fee Name'"
                      [placeholder]="'Service Fee'"
                      [disabled]="!editingFeatures"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="featuresData.serviceFeeNameOverride"></fui-text-control>
                  </fui-column>
                </fui-two-columns>
                @if (editingFeatures) {
                  <fhm-action-buttons>
                    <fhm-remove-button [title]="'fhm.common.button.cancel'"
                    (clicked)="cancelEditFeatures()"></fhm-remove-button>
                    <fhm-provision-button [title]="'fhm.common.button.save'"
                    (clicked)="updateFeatures()"></fhm-provision-button>
                  </fhm-action-buttons>
                }
              </fui-column>
            }
          </fui-row>
        </fui-rows>
      </fui-row>
      <fui-row [label]="'Venues'">
        <fui-column>
          <div class="venues-action">
            <fhm-provision-button [title]="'Add New Venue'" (clicked)="addNewVenue()"></fhm-provision-button>
            <fhm-provision-button [title]="'Add Existing Venue'" (clicked)="addExistingVenue()"></fhm-provision-button>
          </div>
          <fhm-search-grid [records]="venues" [columns]="['name', 'id', 'deploymentStatus']" [type]="'customer-instance.venues'"
            [showLink]="true" (selectRecord)="editVenue($event)">
          </fhm-search-grid>
        </fui-column>
      </fui-row>
    </fui-rows>
  }
</fhm-page>
